<template>
  <div>SafariReservationsDetailFinance</div>
</template>

<script>
export default {
  name: 'SafariReservationsDetailFinance'
}
</script>
